/**
 * Accordion custom element class.
 */
class AccordionElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.attachEvents();
  }

  attachEvents() {
    ['filters:open', 'filters:update', 'accordion:update'].forEach(
      (eventName) => {
        document.addEventListener(eventName, () => {
          this.calcContentHeight();
        });
      },
    );

    ['load', 'resize'].forEach((eventName) => {
      window.addEventListener(eventName, () => {
        this.calcContentHeight();
      });
    });

    this.querySelector('summary').addEventListener('click', (event) => {
      event.preventDefault();

      if (this.querySelector('details').hasAttribute('open')) {
        this.close(this.querySelector('details'));
      } else {
        this.open(this.querySelector('details'));
      }
    });
  }

  close(detailsElement) {
    const content = detailsElement.querySelector('summary').nextElementSibling;

    content.style.maxHeight = 0;

    this.closeAnimation(detailsElement);
  }

  open(detailsElement) {
    const content = detailsElement.querySelector('summary').nextElementSibling;

    content.style.maxHeight = `${content.dataset.maxHeight}px`;

    detailsElement.setAttribute('open', true);
  }

  closeAnimation(detailsElement, delay = 200) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < delay) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  calcContentHeight() {
    const content = this.querySelector('summary').nextElementSibling;
    const contentElement = content.querySelector('[data-content]');
    const isOpen = this.querySelector('details').hasAttribute('open');

    if (!contentElement) return;

    if (!isOpen) {
      this.querySelector('details').setAttribute('open', true);
    }

    const contentHeight = contentElement.offsetHeight;

    if (!isOpen) {
      this.querySelector('details').removeAttribute('open');
    }

    content.setAttribute('data-max-height', contentHeight);

    content.style.height = `${contentHeight}px`;

    if (this.querySelector('details').hasAttribute('open')) {
      content.style.maxHeight = `${contentHeight}px`;
    }
  }
}

customElements.define('accordion-element', AccordionElement);
